import { render, staticRenderFns } from "./report-heatmap.vue?vue&type=template&id=6600a6d0&scoped=true"
import script from "./report-heatmap.vue?vue&type=script&lang=js"
export * from "./report-heatmap.vue?vue&type=script&lang=js"
import style0 from "./report-heatmap.vue?vue&type=style&index=0&id=6600a6d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6600a6d0",
  null
  
)

export default component.exports